module.exports = __webpack_public_path__ + "media/images/lb/546-9e6f971a6ff647a93c7916406706fdc4.svg";